import { useTranslation } from "react-i18next";

import { LoadingGroup, LoadingSkeleton } from "capitalrx-components-2.0/lib/general";
import { Grid, Stack } from "capitalrx-components-2.0/lib/layout";
import { Heading } from "capitalrx-components-2.0/lib/typography";

import { DMRDrugListResponse, DMRDrug } from "@/App/api/drug";

import { DirectMemberReimbursementNoResults } from "./DirectMemberReimbursementNoResults";
import { DirectMemberReimbursementPrescriptionVaccineEquipmentCard } from "./DirectMemberReimbursementPrescriptionVaccineEquipmentCard";

interface PharmacySearchResults {
  readonly largeFieldsColumns: number;
  readonly prescriptionVaccineEquipmentResults?: DMRDrugListResponse;
  readonly isLoadingPrescriptionVaccineEquipmentResults?: boolean;
  readonly setSelectedPrescriptionVaccineEquipment: React.Dispatch<React.SetStateAction<DMRDrug | null>>;
}

const TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.directMemberReimbursementClaimDetailsForm";

export const DirectMemberReimbursementPrescriptionVaccineEquipmentSearchResults = ({
  largeFieldsColumns,
  prescriptionVaccineEquipmentResults,
  isLoadingPrescriptionVaccineEquipmentResults,
  setSelectedPrescriptionVaccineEquipment,
}: PharmacySearchResults) => {
  const { t: translate } = useTranslation();

  return (
    <Grid spacing="medium">
      <Grid.Span columns={largeFieldsColumns}>
        <LoadingGroup loading={isLoadingPrescriptionVaccineEquipmentResults}>
          <LoadingGroup.Placeholder fallback={
            <LoadingSkeleton count={1} style={{ height: "100px" }} />
          }>
          {prescriptionVaccineEquipmentResults?.results.length > 0 && (
            <Stack spacing="medium">
              <Heading>{translate(`${TRANSLATION_PATH}.searchResults`)}</Heading>
              {prescriptionVaccineEquipmentResults?.results.map(({ drug }, index: number) => (
                <DirectMemberReimbursementPrescriptionVaccineEquipmentCard
                  key={`dmr-drug-card-${index}`}
                  dmrDrug={drug}
                  isSelected={false}
                  setSelectedPrescriptionVaccineEquipment={setSelectedPrescriptionVaccineEquipment} />
              ))}
            </Stack>
          )}
          {prescriptionVaccineEquipmentResults?.results.length == 0 && (
            <DirectMemberReimbursementNoResults isSingular={true} />
          )}
          </LoadingGroup.Placeholder>
        </LoadingGroup>
      </Grid.Span>
    </Grid>
  );
};
